/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleGroupAssignment
 */
export interface VehicleGroupAssignment {
    /**
     * 
     * @type {string}
     * @memberof VehicleGroupAssignment
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof VehicleGroupAssignment
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof VehicleGroupAssignment
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof VehicleGroupAssignment
     */
    vehicleGroupId: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleGroupAssignment
     */
    vehicleId: string;
}

/**
 * Check if a given object implements the VehicleGroupAssignment interface.
 */
export function instanceOfVehicleGroupAssignment(value: object): value is VehicleGroupAssignment {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('vehicleGroupId' in value) || value['vehicleGroupId'] === undefined) return false;
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    return true;
}

export function VehicleGroupAssignmentFromJSON(json: any): VehicleGroupAssignment {
    return VehicleGroupAssignmentFromJSONTyped(json, false);
}

export function VehicleGroupAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleGroupAssignment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'vehicleGroupId': json['vehicleGroupId'],
        'vehicleId': json['vehicleId'],
    };
}

export function VehicleGroupAssignmentToJSON(json: any): VehicleGroupAssignment {
    return VehicleGroupAssignmentToJSONTyped(json, false);
}

export function VehicleGroupAssignmentToJSONTyped(value?: VehicleGroupAssignment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'vehicleGroupId': value['vehicleGroupId'],
        'vehicleId': value['vehicleId'],
    };
}

